(function () {
  'use strict';
  if (window.ssHomepageLoading) return;
  var pendingSwiper;
  var mounts = new WeakMap();

  function loadSwiper() {
    if (!pendingSwiper) {
      pendingSwiper = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.async = true;
        script.onload = function () {
          if (typeof window.Swiper === 'function') resolve(window.Swiper);
          else reject(new Error('Swiper unavailable'));
        };
        script.onerror = function () {
          script.remove();
          reject(new Error('Swiper failed to load'));
        };
        document.head.appendChild(script);
      }).catch(function (error) {
        pendingSwiper = null;
        throw error;
      });
    }
    return pendingSwiper;
  }

  function mount(element, initialize) {
    if (mounts.has(element)) return mounts.get(element);
    var observer, instance, started = false, disposed = false;
    function cleanup() {
      if (disposed) return;
      disposed = true;
      if (observer) observer.disconnect();
      if (instance && instance.destroy) instance.destroy(true, true);
      mounts.delete(element);
    }
    function start() {
      if (started || disposed) return;
      started = true;
      if (observer) observer.disconnect();
      loadSwiper().then(function (Swiper) {
        if (!disposed && element.isConnected) instance = initialize(Swiper);
      }).catch(function () {
        // Keep the existing static layout available if the CDN is blocked.
        cleanup();
      });
    }
    mounts.set(element, cleanup);
    if (window.IntersectionObserver && !(window.Shopify && window.Shopify.designMode)) {
      observer = new window.IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) start();
      }, { rootMargin: '400px 0px' });
      observer.observe(element);
    } else start();
    return cleanup;
  }
  window.ssHomepageLoading = { mount: mount };
})();
